import React, { useState, useCallback, useContext, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { add, format, parseISO } from "date-fns";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import {
  Button,
  IconButton,
  Paper,
  Tooltip,
  Typography,
  CircularProgress,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem as MuiMenuItem,
  FormControl,
  InputLabel,
  Switch,
  Checkbox,
  FormControlLabel,
  Tooltip as MuiTooltip,
  TextField,
} from "@material-ui/core";
import {
  Edit,
  CheckCircle,
  SignalCellularConnectedNoInternet2Bar,
  SignalCellularConnectedNoInternet0Bar,
  SignalCellular4Bar,
  CropFree,
  DeleteOutline,
  Facebook,
  Instagram,
  WhatsApp,
  Sync,
  Chat,
  Code,
  HelpOutline,
  Dashboard,
  Send,
  FileCopy,
  ViewModule,
  ViewList,
  FiberManualRecord,
  BatteryFull,
  BatteryAlert,
  Inbox,
  Message,
  SwapHoriz,
  Person,
} from "@material-ui/icons";
import WebhookIcon from '@mui/icons-material/Webhook';
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
// TableRowSkeleton replaced by card skeleton grid

import api from "../../services/api";
import WhatsAppModal from "../../components/WhatsAppModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import QrcodeModal from "../../components/QrcodeModal";
import PairPhoneModal from "../../components/PairPhoneModal";
import GalleraVoiceConnectionButton from "../../components/GalleraVoiceConnectionButton";
import { i18n } from "../../translate/i18n";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import toastError from "../../errors/toastError";
import formatSerializedId from '../../utils/formatSerializedId';
import whatsmeowIcon from "../../assets/whatsmeow.png";
import wahaIcon from "../../assets/waha-icon.png";
import evolutionIcon from "../../assets/evolution-icon.png";
import { AuthContext } from "../../context/Auth/AuthContext";
import usePlans from "../../hooks/usePlans";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ForbiddenPage from "../../components/ForbiddenPage";
import { Can } from "../../components/Can";
import Conecthub360FlowModal from "../../components/Conecthub360FlowModal";
import TelegramBotModal from "../../components/TelegramBotModal";
import TelegramPersonalModal from "../../components/TelegramPersonalModal";
import CloneConnectionModal from "../../components/CloneConnectionModal";

const CHANNEL_LABELS = {
  whatsapp: "WhatsApp",
  wuzapi: "Whatsapp01",
  whatsmeow: "Whatsapp01",
  waha: "Whatsapp02",
  evolution: "Whatsapp03",
  whatsapp_oficial: "WA Oficial",
  facebook: "Facebook",
  instagram: "Instagram",
  webchat: "WebChat",
  telegram: "Telegram",
};

const CHANNEL_COLORS = {
  whatsapp: "#25d366",
  wuzapi: "#128C7E",
  whatsmeow: "#128C7E",
  waha: "#075E54",
  evolution: "#00A884",
  whatsapp_oficial: "#25d366",
  facebook: "#3b5998",
  instagram: "#e1306c",
  webchat: "#0066ff",
  telegram: "#229ED9",
};

const STATUS_MAP = {
  CONNECTED: { label: "Conectado", color: "#4caf50", bg: "rgba(76,175,80,0.10)" },
  DISCONNECTED: { label: "Desconectado", color: "#f44336", bg: "rgba(244,67,54,0.08)" },
  OPENING: { label: "Conectando...", color: "#ff9800", bg: "rgba(255,152,0,0.10)" },
  qrcode: { label: "QR Code", color: "#2196f3", bg: "rgba(33,150,243,0.08)" },
  TIMEOUT: { label: "Timeout", color: "#ff5722", bg: "rgba(255,87,34,0.08)" },
  PAIRING: { label: "Pareando", color: "#ff9800", bg: "rgba(255,152,0,0.10)" },
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.padding,
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  customTableCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: theme.typography.pxToRem(14),
    border: "1px solid #dadde9",
    maxWidth: 450,
  },
  tooltipPopper: {
    textAlign: "center",
  },
  buttonProgress: {
    color: green[500],
  },
  // ─── Card Grid ───
  cardGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))",
    gap: 18,
    padding: "4px 2px",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
  connectionCard: {
    position: "relative",
    borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    overflow: "hidden",
    transition: "box-shadow 0.2s, transform 0.15s",
    "&:hover": {
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      transform: "translateY(-2px)",
    },
  },
  cardColorStripe: {
    position: "absolute",
    top: 0,
    left: 0,
    width: 4,
    height: "100%",
    borderRadius: "14px 0 0 14px",
  },
  cardHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    padding: "12px 12px 6px 20px",
  },
  cardChannelInfo: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  cardChannelIcon: {
    width: 36,
    height: 36,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  cardName: {
    fontSize: 15,
    fontWeight: 700,
    color: theme.palette.text.primary,
    lineHeight: 1.3,
    maxWidth: 200,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  cardChannelLabel: {
    fontSize: 11,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    letterSpacing: 0.4,
  },
  cardStatusChip: {
    fontSize: 11,
    fontWeight: 700,
    borderRadius: 6,
    padding: "2px 10px",
    lineHeight: "20px",
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    letterSpacing: 0.3,
  },
  cardBody: {
    padding: "2px 12px 4px 20px",
  },
  cardInfoRow: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginBottom: 4,
  },
  cardInfoLabel: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    fontWeight: 500,
    minWidth: 60,
  },
  cardInfoValue: {
    fontSize: 13,
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
  cardBadges: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    flexWrap: "wrap",
    marginTop: 6,
  },
  cardSessionArea: {
    padding: "2px 12px 6px 20px",
    display: "flex",
    alignItems: "center",
    gap: 6,
    flexWrap: "wrap",
  },
  cardDivider: {
    margin: "0 16px 0 20px",
    backgroundColor: theme.palette.divider,
  },
  cardActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 2,
    padding: "4px 12px 8px 20px",
  },
  defaultBadge: {
    fontSize: 10,
    fontWeight: 700,
    backgroundColor: "rgba(76,175,80,0.12)",
    color: "#2e7d32",
    borderRadius: 4,
    padding: "2px 8px",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  inboundBadge: {
    fontSize: 10,
    fontWeight: 600,
    backgroundColor: "rgba(33,150,243,0.10)",
    color: "#1565c0",
    borderRadius: 4,
    padding: "2px 8px",
  },
  // ─── Stats Row ───
  cardStatsRow: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    padding: "4px 16px 6px 20px",
    flexWrap: "wrap",
  },
  statChip: {
    fontSize: 10,
    fontWeight: 600,
    borderRadius: 4,
    padding: "2px 7px",
    display: "inline-flex",
    alignItems: "center",
    gap: 3,
    lineHeight: "16px",
  },
  // ─── Health Indicator ───
  healthDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    display: "inline-block",
    flexShrink: 0,
  },
  healthPulse: {
    animation: "$healthPulse 2s ease-in-out infinite",
  },
  "@keyframes healthPulse": {
    "0%, 100%": { opacity: 1, transform: "scale(1)" },
    "50%": { opacity: 0.5, transform: "scale(1.3)" },
  },
  batteryIndicator: {
    display: "inline-flex",
    alignItems: "center",
    gap: 3,
    fontSize: 11,
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  // ─── Compact / List Mode ───
  viewToggle: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    marginLeft: "auto",
  },
  viewToggleBtn: {
    minWidth: 32,
    padding: "4px 8px",
    borderRadius: 6,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: "transparent",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.15s",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  viewToggleBtnActive: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    borderColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  // ─── Compact List Item ───
  compactList: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  compactItem: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "10px 16px",
    borderRadius: 10,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    transition: "background-color 0.15s",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  compactColorDot: {
    width: 4,
    height: 32,
    borderRadius: 2,
    flexShrink: 0,
  },
  compactChannelIcon: {
    width: 28,
    height: 28,
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    "& svg": { fontSize: 18 },
    "& img": { width: 18, height: 18 },
  },
  compactName: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.primary,
    minWidth: 120,
    maxWidth: 180,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  compactPhone: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    minWidth: 100,
  },
  compactStatusDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    flexShrink: 0,
  },
  compactStats: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 11,
    color: theme.palette.text.secondary,
    marginLeft: "auto",
  },
  compactActions: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    marginLeft: 8,
  },
  // ─── Skeletons ───
  cardSkeletonGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))",
    gap: 18,
    padding: "4px 2px",
  },
  cardSkeleton: {
    borderRadius: 14,
    height: 180,
    backgroundColor: theme.palette.grey[100],
    animation: "$pulse 1.5s ease-in-out infinite",
  },
  "@keyframes pulse": {
    "0%, 100%": { opacity: 0.6 },
    "50%": { opacity: 1 },
  },
}));

function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="determinate" {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          color="textSecondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

const CustomToolTip = ({ title, content, children }) => {
  const classes = useStyles();

  return (
    <Tooltip
      arrow
      classes={{
        tooltip: classes.tooltip,
        popper: classes.tooltipPopper,
      }}
      title={
        <React.Fragment>
          <Typography gutterBottom color="inherit">
            {title}
          </Typography>
          {content && <Typography>{content}</Typography>}
        </React.Fragment>
      }
    >
      {children}
    </Tooltip>
  );
};

const IconChannel = (channel) => {
  // Normalizar channel para lowercase para comparação case-insensitive
  const normalizedChannel = channel ? channel.toLowerCase().trim() : "";
  
  // Debug: log para verificar qual channel está chegando
  if (normalizedChannel === "wuzapi" || normalizedChannel === "whatsmeow") {
    console.log("[IconChannel] Channel detectado:", normalizedChannel, "Original:", channel);
  }
  
  switch (normalizedChannel) {
    case "facebook":
      return <Facebook style={{ color: "#3b5998" }} />;
    case "instagram":
      return <Instagram style={{ color: "#e1306c" }} />;
    case "whatsapp":
      return <WhatsApp style={{ color: "#25d366" }} />;
    case "whatsapp_oficial":
      return <WhatsApp style={{ color: "#25d366" }} />;
    case "waha":
      return (
        <img
          src={wahaIcon}
          alt="Whatsapp02"
          style={{ width: 24, height: 24, objectFit: "contain" }}
        />
      );
    case "evolution":
      return (
        <img
          src={evolutionIcon}
          alt="Whatsapp03"
          style={{ width: 24, height: 24, objectFit: "contain" }}
        />
      );
    case "wuzapi":
      return (
        <img
          src={whatsmeowIcon}
          alt="Whatsapp01"
          style={{ width: 24, height: 24, objectFit: "contain" }}
          onError={(e) => {
            console.error("[IconChannel] Erro ao carregar whatsmeow.png:", e);
            e.target.style.display = 'none';
          }}
          onLoad={() => {
            console.log("[IconChannel] ✅ whatsmeow.png carregado com sucesso!");
          }}
        />
      );
    case "whatsmeow":
      return (
        <img
          src={whatsmeowIcon}
          alt="Whatsapp01"
          style={{ width: 24, height: 24, objectFit: "contain" }}
          onError={(e) => {
            console.error("[IconChannel] Erro ao carregar whatsmeow.png:", e);
            e.target.style.display = 'none';
          }}
          onLoad={() => {
            console.log("[IconChannel] ✅ whatsmeow.png carregado com sucesso!");
          }}
        />
      );
    case "webchat":
      return <Chat style={{ color: "#0066ff" }} />;
    case "telegram":
      return <Send style={{ color: "#229ED9" }} />;
    default:
      // Se não encontrar, retornar WhatsApp como fallback
      console.warn("[IconChannel] Channel desconhecido:", channel, "normalized:", normalizedChannel);
      return <WhatsApp style={{ color: "#25d366" }} />;
  }
};

const Connections = () => {
  const classes = useStyles();

  const { whatsApps, loading } = useContext(WhatsAppsContext);
  const [whatsAppModalOpen, setWhatsAppModalOpen] = useState(false);
  
  // Log via useEffect para garantir execução
  useEffect(() => {
    console.log("[DEBUG] Connections useEffect - whatsApps:", whatsApps, "loading:", loading);
    if (whatsApps && whatsApps.length > 0) {
      whatsApps.forEach((wa) => {
        console.log("[DEBUG] Conexão encontrada - ID:", wa.id, "Channel:", wa.channel, "Status:", wa.status, "Nome:", wa.name);
      });
    }
  }, [whatsApps, loading]);
  const [statusImport, setStatusImport] = useState([]);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [pairPhoneModalOpen, setPairPhoneModalOpen] = useState(false);
  const [selectedWhatsApp, setSelectedWhatsApp] = useState(null);
  const [channel, setChannel] = useState("whatsapp");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const history = useHistory();
  const confirmationModalInitialState = {
    action: "",
    title: "",
    message: "",
    whatsAppId: "",
    open: false,
  };
  const [confirmModalInfo, setConfirmModalInfo] = useState(confirmationModalInitialState);
  const [planConfig, setPlanConfig] = useState(false);
  const [conecthub360ModalOpen, setConecthub360ModalOpen] = useState(false);
  const [telegramBotModalOpen, setTelegramBotModalOpen] = useState(false);
  const [telegramPersonalModalOpen, setTelegramPersonalModalOpen] = useState(false);
  const [transferModalOpen, setTransferModalOpen] = useState(false);
  const [sourceConnection, setSourceConnection] = useState("");
  const [targetConnection, setTargetConnection] = useState("");
  const [includeTicketsWithoutConnection, setIncludeTicketsWithoutConnection] = useState(false);
  const [preDeleteModalOpen, setPreDeleteModalOpen] = useState(false);
  const [whatsAppToDelete, setWhatsAppToDelete] = useState(null);
  const [deleteConfirmText, setDeleteConfirmText] = useState("");
  const [cloneModalOpen, setCloneModalOpen] = useState(false);
  const [cloneSource, setCloneSource] = useState(null);
  const [transferProgressModalOpen, setTransferProgressModalOpen] = useState(false);
  const [transferProgress, setTransferProgress] = useState({
    current: 0,
    total: 0,
    percentage: 0,
    failed: 0,
    jobId: null
  });
  const [connectionStats, setConnectionStats] = useState({});
  const [viewMode, setViewMode] = useState(() => {
    try { return localStorage.getItem("connections_viewMode") || "cards"; }
    catch { return "cards"; }
  });

  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const companyId = user.companyId;

  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      const planConfigs = await getPlanCompany(undefined, companyId);
      setPlanConfig(planConfigs)
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetch connection stats
  const statsDebounceRef = useRef(null);

  const fetchStats = useCallback(async () => {
    try {
      const { data } = await api.get("/whatsapp/stats");
      // Stats loaded silently
      setConnectionStats(data);
    } catch (err) {
      console.warn("[Connections] Failed to fetch stats:", err?.response?.status, err?.message);
    }
  }, []);

  // Debounced re-fetch: agrupa multiplos eventos em uma unica chamada
  const debouncedFetchStats = useCallback(() => {
    if (statsDebounceRef.current) clearTimeout(statsDebounceRef.current);
    statsDebounceRef.current = setTimeout(() => {
      fetchStats();
    }, 3000);
  }, [fetchStats]);

  // Initial fetch + polling fallback every 60s
  useEffect(() => {
    fetchStats();
    const interval = setInterval(fetchStats, 60000);
    return () => clearInterval(interval);
  }, [fetchStats]);

  // Real-time: escuta eventos de ticket para atualizar stats via socket
  useEffect(() => {
    if (!socket || typeof socket.on !== "function") return;

    const onTicketChange = (data) => {
      if (data.action === "update" || data.action === "create" || data.action === "delete") {
        debouncedFetchStats();
      }
    };

    socket.on(`company-${user.companyId}-ticket`, onTicketChange);

    return () => {
      if (socket && typeof socket.off === "function") {
        socket.off(`company-${user.companyId}-ticket`, onTicketChange);
      }
      if (statsDebounceRef.current) clearTimeout(statsDebounceRef.current);
    };
  }, [socket, user.companyId, debouncedFetchStats]);

  // Persist view mode
  const handleChangeViewMode = (mode) => {
    setViewMode(mode);
    try { localStorage.setItem("connections_viewMode", mode); } catch {}
  };

  // Health helper: time since last update
  const getTimeSinceUpdate = (updatedAt) => {
    if (!updatedAt) return "";
    const diff = Date.now() - new Date(updatedAt).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return "agora";
    if (mins < 60) return `${mins}min`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h`;
    return `${Math.floor(hrs / 24)}d`;
  };

  const responseFacebook = (response) => {
    if (response.status !== "unknown") {
      const { accessToken, id } = response;

      api
        .post("/facebook", {
          facebookUserId: id,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          toast.success(i18n.t("connections.facebook.success"));
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  const responseInstagram = (response) => {
    if (response.status !== "unknown") {
      const { accessToken, id } = response;

      api
        .post("/facebook", {
          addInstagram: true,
          facebookUserId: id,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          toast.success(i18n.t("connections.facebook.success"));
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  useEffect(() => {
    // const socket = socketManager.GetSocket();

    if (!socket || typeof socket.on !== 'function') {
      return;
    }

    const onImportMessages = (data) => {
      if (data.action === "refresh") {
        setStatusImport([]);
        history.go(0);
      }
      if (data.action === "update") {
        setStatusImport(data.status);
      }
    };

    const onTransferTickets = (data) => {
      console.log("[TRANSFER FRONTEND] Evento recebido:", data);
      
      if (data.action === "progress") {
        console.log(`[TRANSFER FRONTEND] Progresso: ${data.current}/${data.total} (${data.percentage}%)`);
        setTransferProgress({
          current: data.current,
          total: data.total,
          percentage: data.percentage || Math.round((data.current / data.total) * 100),
          failed: data.failed || 0,
          jobId: data.jobId
        });
      }
      if (data.action === "completed") {
        setTransferProgressModalOpen(false);
        const successMsg = data.failed > 0
          ? `Transferência concluída! ${data.transferred} tickets transferidos com sucesso. ${data.failed} tickets falharam.`
          : `Transferência concluída! ${data.transferred} tickets transferidos com sucesso.`;
        toast.success(successMsg);
        setTransferProgress({ current: 0, total: 0, percentage: 0, failed: 0, jobId: null });
        handleCloseTransferModal();
      }
      if (data.action === "error") {
        setTransferProgressModalOpen(false);
        setTransferProgress({ current: 0, total: 0, percentage: 0, failed: 0, jobId: null });
        toast.error("Erro na transferência de tickets.");
      }
      if (data.action === "cancelled") {
        setTransferProgressModalOpen(false);
        setTransferProgress({ current: 0, total: 0, percentage: 0, failed: 0, jobId: null });
        toast.warning(`Transferência cancelada. ${data.transferred} tickets foram transferidos antes do cancelamento.`);
      }
    };

    socket.on(`importMessages-${user.companyId}`, onImportMessages);
    socket.on(`transferTickets-${user.companyId}`, onTransferTickets);

    return () => {
      if (socket && typeof socket.off === 'function') {
        socket.off(`importMessages-${user.companyId}`, onImportMessages);
        socket.off(`transferTickets-${user.companyId}`, onTransferTickets);
      }
    };
  }, [whatsApps, socket, user.companyId, history]);

  const handleStartWhatsAppSession = async (whatsAppId) => {
    console.log("[FRONTEND-DEBUG] ========== handleStartWhatsAppSession CHAMADO ==========");
    console.log("[FRONTEND-DEBUG] WhatsApp ID:", whatsAppId);
    console.log("[FRONTEND-DEBUG] URL:", `/whatsappsession/${whatsAppId}`);
    console.log("[FRONTEND-DEBUG] Base URL:", process.env.REACT_APP_BACKEND_URL);
    try {
      console.log("[FRONTEND-DEBUG] Fazendo POST para:", `${process.env.REACT_APP_BACKEND_URL}/whatsappsession/${whatsAppId}`);
      const response = await api.post(`/whatsappsession/${whatsAppId}`);
      console.log("[FRONTEND-DEBUG] ✅ Resposta recebida:", response);
    } catch (err) {
      console.error("[FRONTEND-DEBUG] ❌ ERRO na requisição:", err);
      console.error("[FRONTEND-DEBUG] Erro completo:", JSON.stringify(err, null, 2));
      toastError(err);
    }
  };

  const handleRequestNewQrCode = async (whatsAppId) => {
    console.log("[FRONTEND-DEBUG] ========== handleRequestNewQrCode CHAMADO ==========");
    console.log("[FRONTEND-DEBUG] WhatsApp ID:", whatsAppId);
    console.log("[FRONTEND-DEBUG] URL:", `/whatsappsession/${whatsAppId}`);
    console.log("[FRONTEND-DEBUG] Base URL:", process.env.REACT_APP_BACKEND_URL);
    try {
      console.log("[FRONTEND-DEBUG] Fazendo PUT para:", `${process.env.REACT_APP_BACKEND_URL}/whatsappsession/${whatsAppId}`);
      const response = await api.put(`/whatsappsession/${whatsAppId}`);
      console.log("[FRONTEND-DEBUG] ✅ Resposta recebida:", response);
    } catch (err) {
      console.error("[FRONTEND-DEBUG] ❌ ERRO na requisição:", err);
      console.error("[FRONTEND-DEBUG] Erro completo:", JSON.stringify(err, null, 2));
      toastError(err);
    }
  };

  const handleOpenWhatsAppModal = (channel) => {
    setChannel(channel)
    setSelectedWhatsApp(null);
    setWhatsAppModalOpen(true);
  };

  const handleCloseWhatsAppModal = useCallback(() => {
    setWhatsAppModalOpen(false);
    setSelectedWhatsApp(null);
    setChannel("whatsapp"); // Resetar para o padrão
  }, [setSelectedWhatsApp, setWhatsAppModalOpen]);

  const handleOpenQrModal = (whatsApp) => {
    setSelectedWhatsApp(whatsApp);
    setQrModalOpen(true);
  };

  const handleCloseQrModal = useCallback(() => {
    setSelectedWhatsApp(null);
    setQrModalOpen(false);
  }, [setQrModalOpen, setSelectedWhatsApp]);

  const handleOpenPairPhoneModal = (whatsApp) => {
    setSelectedWhatsApp(whatsApp);
    setPairPhoneModalOpen(true);
  };

  const handleClosePairPhoneModal = useCallback(() => {
    setSelectedWhatsApp(null);
    setPairPhoneModalOpen(false);
  }, [setSelectedWhatsApp]);

  const handleEditWhatsApp = (whatsApp) => {
    setChannel(whatsApp.channel)
    setSelectedWhatsApp(whatsApp);
    setWhatsAppModalOpen(true);
  };

  const handleSyncTemplates = async (whatsAppId) => {
    await api.get(`/whatsapp/sync-templates/${whatsAppId}`);
  };

  const handleToggleReceiveComments = async (whatsApp) => {
    try {
      const newValue = !whatsApp.receiveComments;
      await api.put(`/whatsapp/${whatsApp.id}`, {
        receiveComments: newValue
      });
      toast.success(
        newValue 
          ? i18n.t("connections.receiveComments.enabled") 
          : i18n.t("connections.receiveComments.disabled")
      );
    } catch (err) {
      toastError(err);
    }
  };

  const handleCopyWebhook = (whatsApp) => {
    if (!whatsApp) return;

    // 1) Tenta usar o webhook salvo no banco (criado automaticamente pela API oficial)
    let url = whatsApp.waba_webhook;

    // 2) Se não tiver salvo, monta a URL padrão do backend
    if (!url) {
      const base =
        (process.env.REACT_APP_BACKEND_URL &&
          process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "")) ||
        window.location.origin.replace(/\/$/, "");

      const companyId = whatsApp.companyId || user.companyId;
      url = `${base}/v1/webhook/${companyId}/${whatsApp.id}`;
    }

    if (!url) {
      toast.error("Não foi possível gerar a URL do webhook.");
      return;
    }

    navigator.clipboard
      .writeText(url)
      .then(() => {
        toast.success("Webhook copiado para a área de transferência!");
      })
      .catch(() => {
        toast.error("Erro ao copiar o webhook. Tente novamente.");
      });
  };

  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleOpenConfirmationModal = (action, whatsAppId) => {
    if (action === "disconnect") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.disconnectTitle"),
        message: i18n.t("connections.confirmationModal.disconnectMessage"),
        whatsAppId: whatsAppId,
      });
    }

    if (action === "delete") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.deleteTitle"),
        message: i18n.t("connections.confirmationModal.deleteMessage"),
        whatsAppId: whatsAppId,
      });
    }
    if (action === "closedImported") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.closedImportedTitle"),
        message: i18n.t("connections.confirmationModal.closedImportedMessage"),
        whatsAppId: whatsAppId,
      });
    }

    setConfirmModalOpen(true);
  };

  const handleSubmitConfirmationModal = async () => {
    if (confirmModalInfo.action === "disconnect") {
      try {
        await api.delete(`/whatsappsession/${confirmModalInfo.whatsAppId}`);
      } catch (err) {
        toastError(err);
      }
    }

    if (confirmModalInfo.action === "delete") {
      try {
        await api.delete(`/whatsapp/${confirmModalInfo.whatsAppId}`);
        toast.success(i18n.t("connections.toasts.deleted"));
      } catch (err) {
        toastError(err);
      }
    }
    if (confirmModalInfo.action === "closedImported") {
      try {
        await api.post(`/closedimported/${confirmModalInfo.whatsAppId}`);
        toast.success(i18n.t("connections.toasts.closedimported"));
      } catch (err) {
        toastError(err);
      }
    }


    setConfirmModalInfo(confirmationModalInitialState);
  };


  const renderImportButton = (whatsApp) => {
    if (whatsApp?.statusImportMessages === "renderButtonCloseTickets") {
      return (
        <Button
          style={{ marginLeft: 12 }}
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => {
            handleOpenConfirmationModal("closedImported", whatsApp.id);
          }}
        >
          {i18n.t("connections.buttons.closedImported")}
        </Button>
      );
    }

    if (whatsApp?.importOldMessages) {
      let isTimeStamp = !isNaN(
        new Date(Math.floor(whatsApp?.statusImportMessages)).getTime()
      );

      if (isTimeStamp) {
        const ultimoStatus = new Date(
          Math.floor(whatsApp?.statusImportMessages)
        ).getTime();
        const dataLimite = +add(ultimoStatus, { seconds: +35 }).getTime();
        if (dataLimite > new Date().getTime()) {
          return (
            <>
              <Button
                disabled
                style={{ marginLeft: 12 }}
                size="small"
                endIcon={
                  <CircularProgress
                    size={12}
                    className={classes.buttonProgress}
                  />
                }
                variant="outlined"
                color="primary"
              >
                {i18n.t("connections.buttons.preparing")}
              </Button>
            </>
          );
        }
      }
    }
  };

  const renderActionButtons = (whatsApp) => {
    // Log SEMPRE para debug
    console.log("[DEBUG] renderActionButtons CHAMADO - ID:", whatsApp?.id, "Channel:", whatsApp?.channel, "Status:", whatsApp?.status, "Full object:", whatsApp);
    
    // Debug: verificar channel e status
    const isWebchat = whatsApp?.channel === "webchat" || whatsApp?.channel?.toLowerCase() === "webchat";
    const isConnected = whatsApp?.status === "CONNECTED" || whatsApp?.status?.toUpperCase() === "CONNECTED";
    
    if (isWebchat) {
      console.log("[DEBUG] ✅ WebChat detectado! Status:", whatsApp?.status, "isConnected:", isConnected);
    }
    
    return (
      <>
        {(whatsApp.channel === "whatsapp" || whatsApp.channel === "whatsmeow" || whatsApp.channel === "wuzapi" || whatsApp.channel === "waha" || whatsApp.channel === "evolution") && whatsApp.status === "qrcode" && (
          <Can
            role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
            perform="connections-page:addConnection"
            yes={() => (
              <>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    console.log("[FRONTEND-DEBUG] Botão QR CODE clicado - WhatsApp ID:", whatsApp.id);
                    handleOpenQrModal(whatsApp);
                  }}
                >
                  {i18n.t("connections.buttons.qrcode")}
                </Button>
                {(whatsApp.channel === "wuzapi" || whatsApp.channel === "whatsmeow" || whatsApp.channel === "waha" || whatsApp.channel === "evolution" || whatsApp.channel === "whatsapp") && (
                  <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      console.log("[FRONTEND-DEBUG] Botão PairPhone clicado - WhatsApp ID:", whatsApp.id);
                      handleOpenPairPhoneModal(whatsApp);
                    }}
                    style={{ marginLeft: 8 }}
                  >
                    Conectar via Telefone
                  </Button>
                )}
              </>
            )}
          />
        )}
        {(whatsApp.channel === "whatsapp" || whatsApp.channel === "whatsmeow" || whatsApp.channel === "wuzapi" || whatsApp.channel === "waha" || whatsApp.channel === "evolution") && (whatsApp.status === "DISCONNECTED" || whatsApp.status === "TIMEOUT") && (
          <Can
            role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
            perform="connections-page:addConnection"
            yes={() => (
              <>
                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    console.log("[FRONTEND-DEBUG] Botão 'Tentar Novamente' clicado - WhatsApp ID:", whatsApp.id, "Channel:", whatsApp.channel);
                    handleStartWhatsAppSession(whatsApp.id);
                  }}
                >
                  {i18n.t("connections.buttons.tryAgain")}
                </Button>{" "}
                <Button
                  size="small"
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    console.log("[FRONTEND-DEBUG] Botão 'Novo QR CODE' clicado - WhatsApp ID:", whatsApp.id, "Channel:", whatsApp.channel);
                    handleRequestNewQrCode(whatsApp.id);
                  }}
                >
                  {i18n.t("connections.buttons.newQr")}
                </Button>
              </>
            )}
          />
        )}
        {((whatsApp.channel === "whatsapp" || whatsApp.channel === "whatsmeow" || whatsApp.channel === "wuzapi" || whatsApp.channel === "waha" || whatsApp.channel === "evolution") && (whatsApp.status === "CONNECTED" ||
          whatsApp.status === "PAIRING" ||
          whatsApp.status === "TIMEOUT")) && (
            <Can
              role={user.profile}
              perform="connections-page:addConnection"
              yes={() => (
                <>
                  <Button
                    size="small"
                    variant="outlined"
                    color="secondary"
                    onClick={() => {
                      handleOpenConfirmationModal("disconnect", whatsApp.id);
                    }}
                  >
                    {i18n.t("connections.buttons.disconnect")}
                  </Button>

                  {renderImportButton(whatsApp)}

                  {/* gallera-voice FASE 2: ativar/parear a voz deste número
                      (auto-oculto se o plano/servidor não tiver voz) */}
                  {whatsApp.status === "CONNECTED" && (
                    <GalleraVoiceConnectionButton whatsapp={whatsApp} />
                  )}
                </>
              )}
            />
          )}
        {((whatsApp.channel === "whatsapp" || whatsApp.channel === "whatsmeow" || whatsApp.channel === "wuzapi" || whatsApp.channel === "waha" || whatsApp.channel === "evolution") && whatsApp.status === "OPENING") && (
          <Button size="small" variant="outlined" disabled color="default">
            {i18n.t("connections.buttons.connecting")}
          </Button>
        )}
        {(whatsApp.channel === "webchat" && (whatsApp.status === "CONNECTED" ||
          whatsApp.status === "PAIRING" ||
          whatsApp.status === "TIMEOUT")) && (
            <Can
              role={user.profile}
              perform="connections-page:addConnection"
              yes={() => (
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  startIcon={<Code />}
                  onClick={() => {
                    handleEditWhatsApp(whatsApp);
                  }}
                >
                  Ver Código
                </Button>
              )}
            />
          )}
      </>
    );
  };

  const renderStatusToolTips = (whatsApp) => {
    return (
      <div className={classes.customTableCell}>
        {whatsApp.status === "DISCONNECTED" && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.disconnected.title")}
            content={i18n.t("connections.toolTips.disconnected.content")}
          >
            <SignalCellularConnectedNoInternet0Bar color="secondary" />
          </CustomToolTip>
        )}
        {whatsApp.status === "OPENING" && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
        {whatsApp.status === "qrcode" && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.qrcode.title")}
            content={i18n.t("connections.toolTips.qrcode.content")}
          >
            <CropFree />
          </CustomToolTip>
        )}
        {whatsApp.status === "CONNECTED" && (
          <CustomToolTip title={i18n.t("connections.toolTips.connected.title")}>
            <SignalCellular4Bar style={{ color: green[500] }} />
          </CustomToolTip>
        )}
        {(whatsApp.status === "TIMEOUT" || whatsApp.status === "PAIRING") && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.timeout.title")}
            content={i18n.t("connections.toolTips.timeout.content")}
          >
            <SignalCellularConnectedNoInternet2Bar color="secondary" />
          </CustomToolTip>
        )}
      </div>
    );
  };

  const restartWhatsapps = async () => {

    try {
      await api.post(`/whatsapp-restart/`);
      toast.success(i18n.t("connections.waitConnection"));
    } catch (err) {
      toastError(err);
    }
  }

  const handleOpenTransferModal = (prefilledSourceId) => {
    if (prefilledSourceId) {
      setSourceConnection(prefilledSourceId);
    }
    setTransferModalOpen(true);
  };

  const handleCloseTransferModal = () => {
    setTransferModalOpen(false);
    setSourceConnection("");
    setTargetConnection("");
    setIncludeTicketsWithoutConnection(false);
  };

  const handleCloseTransferProgressModal = () => {
    setTransferProgressModalOpen(false);
    setTransferProgress({ current: 0, total: 0, percentage: 0, failed: 0, jobId: null });
  };

  const handleCancelTransfer = async () => {
    if (!transferProgress.jobId) {
      toast.error("Não é possível cancelar esta transferência.");
      return;
    }

    try {
      await api.post(`/transfer-tickets/${transferProgress.jobId}/cancel`);
      toast.info("Cancelamento solicitado. Aguarde...");
    } catch (err) {
      toastError(err);
    }
  };

  const handleTransferTickets = async () => {
    if (!targetConnection) {
      toast.error("Selecione a conexão de destino");
      return;
    }

    // Se não estiver marcado para incluir tickets sem conexão, precisa selecionar origem
    if (!includeTicketsWithoutConnection) {
      if (!sourceConnection) {
        toast.error("Selecione a conexão de origem");
        return;
      }

      if (sourceConnection === targetConnection) {
        toast.error("As conexões de origem e destino devem ser diferentes");
        return;
      }
    }

    try {
      const response = await api.post(`/transfer-tickets`, {
        sourceConnectionId: includeTicketsWithoutConnection ? null : sourceConnection,
        targetConnectionId: targetConnection,
        includeTicketsWithoutConnection: includeTicketsWithoutConnection
      });

      if (response.data.requiresProgress) {
        setTransferModalOpen(false);
        setTransferProgressModalOpen(true);
        setTransferProgress({ 
          current: 0, 
          total: response.data.totalTickets, 
          percentage: 0,
          failed: 0,
          jobId: response.data.jobId 
        });
      } else {
        const successMsg = response.data.failed > 0
          ? `Transferência concluída! ${response.data.transferred || 0} tickets transferidos. ${response.data.failed} tickets falharam.`
          : `Tickets transferidos com sucesso! ${response.data.transferred || 0} tickets transferidos.`;
        toast.success(successMsg);
        handleCloseTransferModal();
      }
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenPreDeleteModal = (whatsAppId) => {
    setWhatsAppToDelete(whatsAppId);
    setDeleteConfirmText("");
    setPreDeleteModalOpen(true);
  };

  const handleClosePreDeleteModal = () => {
    setPreDeleteModalOpen(false);
    setWhatsAppToDelete(null);
    setDeleteConfirmText("");
  };

  const handleConfirmDelete = async () => {
    if (deleteConfirmText !== "EXCLUIR CONEXAO") return;
    try {
      await api.delete(`/whatsapp/${whatsAppToDelete}`);
      toast.success(i18n.t("connections.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    handleClosePreDeleteModal();
  };

  return (
    <MainContainer>
      <ConfirmationModal
        title={confirmModalInfo.title}
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={handleSubmitConfirmationModal}
      >
        {confirmModalInfo.message}
      </ConfirmationModal>
      {qrModalOpen && (
        <QrcodeModal
          open={qrModalOpen}
          onClose={handleCloseQrModal}
          whatsAppId={!whatsAppModalOpen && selectedWhatsApp?.id}
          onOpenPairPhone={() => {
            handleCloseQrModal();
            handleOpenPairPhoneModal(selectedWhatsApp);
          }}
          channel={selectedWhatsApp?.channel}
        />
      )}
      {pairPhoneModalOpen && (
        <PairPhoneModal
          open={pairPhoneModalOpen}
          onClose={handleClosePairPhoneModal}
          whatsAppId={selectedWhatsApp?.id}
        />
      )}
      <WhatsAppModal
        open={whatsAppModalOpen}
        onClose={handleCloseWhatsAppModal}
        whatsAppId={!qrModalOpen && selectedWhatsApp?.id}
        channel={channel}
      />
      <CloneConnectionModal
        open={cloneModalOpen}
        onClose={() => { setCloneModalOpen(false); setCloneSource(null); }}
        sourceWhatsapp={cloneSource}
      />
      <Conecthub360FlowModal
        open={conecthub360ModalOpen}
        onClose={() => setConecthub360ModalOpen(false)}
        planWhatsapp={planConfig?.plan?.useWhatsapp}
        planWhatsappOfficial={planConfig?.plan?.useWhatsappOfficial}
        planFacebook={planConfig?.plan?.useFacebook}
        planInstagram={planConfig?.plan?.useInstagram}
        planConecthub360={planConfig?.plan?.useConecthub360}
      />
      <TelegramBotModal
        open={telegramBotModalOpen}
        onClose={() => setTelegramBotModalOpen(false)}
        onCompleted={() => {
          setTelegramBotModalOpen(false);
        }}
      />
      <TelegramPersonalModal
        open={telegramPersonalModalOpen}
        onClose={() => setTelegramPersonalModalOpen(false)}
        onCompleted={() => {
          setTelegramPersonalModalOpen(false);
        }}
      />
      <Dialog
        open={transferModalOpen}
        onClose={handleCloseTransferModal}
        maxWidth="sm"
        fullWidth
        PaperProps={{ style: { borderRadius: 16 } }}
      >
        <DialogTitle style={{ paddingBottom: 0 }}>
          <Box display="flex" alignItems="center" style={{ gap: 10 }}>
            <SwapHoriz style={{ color: "#1976d2", fontSize: 28 }} />
            <Typography variant="h6" style={{ fontWeight: 700 }}>
              Transferencia de Tickets
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {(() => {
            const prefilledSource = sourceConnection ? whatsApps.find(w => w.id === sourceConnection) : null;
            return (
              <>
                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 20, marginTop: 8, lineHeight: 1.6 }}>
                  {prefilledSource
                    ? <>Transfira todos os tickets de <strong>{prefilledSource.name}</strong> para outra conexao.</>
                    : <>Selecione a conexao de <strong>origem</strong> e a de <strong>destino</strong> para mover os tickets.</>
                  }
                </Typography>

                <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginBottom: 24 }}>
                  <FormControl fullWidth>
                    <InputLabel>Origem</InputLabel>
                    <Select
                      value={sourceConnection}
                      onChange={(e) => setSourceConnection(e.target.value)}
                      label="Origem"
                      disabled={!!prefilledSource || includeTicketsWithoutConnection}
                    >
                      {whatsApps.map((wa) => (
                        <MuiMenuItem key={wa.id} value={wa.id}>
                          {wa.name}
                        </MuiMenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <SwapHoriz style={{ fontSize: 28, color: '#4caf50', flexShrink: 0 }} />

                  <FormControl fullWidth>
                    <InputLabel>Destino</InputLabel>
                    <Select
                      value={targetConnection}
                      onChange={(e) => setTargetConnection(e.target.value)}
                      label="Destino"
                    >
                      {whatsApps
                        .filter((wa) => wa.id !== sourceConnection)
                        .map((wa) => (
                          <MuiMenuItem key={wa.id} value={wa.id}>
                            {wa.name}
                          </MuiMenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>

                {!prefilledSource && (
                  <div style={{ marginTop: 8, marginBottom: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <MuiTooltip
                      title="Marcando esse CheckBox, o sistema vai buscar os tickets sem fila, recurso ideal, para caso tenha apagado a conexao, sem antes transferir os tickets."
                      arrow
                      placement="top"
                    >
                      <HelpOutline style={{ color: '#1976d2', cursor: 'help', fontSize: 20 }} />
                    </MuiTooltip>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={includeTicketsWithoutConnection}
                          onChange={(e) => setIncludeTicketsWithoutConnection(e.target.checked)}
                          color="primary"
                        />
                      }
                      label="TRANSFERIR TICKETS SEM CONEXAO TAMBEM"
                    />
                  </div>
                )}
              </>
            );
          })()}
        </DialogContent>
        <DialogActions style={{ padding: "12px 24px 20px" }}>
          <Button onClick={handleCloseTransferModal} style={{ textTransform: "none", fontWeight: 600 }}>
            Cancelar
          </Button>
          <Button onClick={handleTransferTickets} color="primary" variant="contained" style={{ textTransform: "none", fontWeight: 700, borderRadius: 8 }}>
            Transferir tickets
          </Button>
        </DialogActions>
      </Dialog>
       <Dialog
         open={transferProgressModalOpen}
         onClose={handleCloseTransferProgressModal}
         maxWidth="sm"
         fullWidth
         disableBackdropClick
         disableEscapeKeyDown
       >
         <DialogTitle>Transferindo Tickets</DialogTitle>
         <DialogContent>
           <div style={{ textAlign: 'center', padding: '20px 0' }}>
             <Typography variant="h6" style={{ marginBottom: 16 }}>
               Progresso da Transferência
             </Typography>
             
             <Box position="relative" display="inline-flex" marginBottom={2}>
               <CircularProgress 
                 variant="determinate" 
                 value={transferProgress.percentage} 
                 size={80}
                 thickness={4}
               />
               <Box
                 top={0}
                 left={0}
                 bottom={0}
                 right={0}
                 position="absolute"
                 display="flex"
                 alignItems="center"
                 justifyContent="center"
               >
                 <Typography variant="caption" component="div" color="textSecondary" style={{ fontSize: '14px', fontWeight: 'bold' }}>
                   {transferProgress.percentage}%
                 </Typography>
               </Box>
             </Box>

             <Typography variant="body1" style={{ marginTop: 16 }}>
               {transferProgress.current} de {transferProgress.total} tickets transferidos
             </Typography>
             
             {transferProgress.failed > 0 && (
               <Typography variant="body2" color="error" style={{ marginTop: 8 }}>
                 {transferProgress.failed} tickets falharam na transferência
               </Typography>
             )}
             
             <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
               Por favor, aguarde enquanto os tickets são transferidos...
             </Typography>
           </div>
         </DialogContent>
         <DialogActions>
           <Button 
             onClick={handleCancelTransfer} 
             color="secondary" 
             variant="outlined"
             disabled={!transferProgress.jobId || transferProgress.percentage === 100}
           >
             CANCELAR TRANSFERÊNCIA
           </Button>
         </DialogActions>
       </Dialog>
       <Dialog
         open={preDeleteModalOpen}
         onClose={handleClosePreDeleteModal}
         maxWidth="sm"
         fullWidth
         PaperProps={{ style: { borderRadius: 16 } }}
       >
         <DialogTitle style={{ paddingBottom: 0 }}>
           <Box display="flex" alignItems="center" style={{ gap: 10 }}>
             <DeleteOutline style={{ color: "#d32f2f", fontSize: 28 }} />
             <Typography variant="h6" style={{ fontWeight: 700, color: "#d32f2f" }}>
               Excluir conexao
             </Typography>
           </Box>
         </DialogTitle>
         <DialogContent>
           {(() => {
             const conn = whatsApps.find(w => w.id === whatsAppToDelete);
             const connName = conn?.name || "";
             return (
               <>
                 <Box style={{
                   backgroundColor: "#fff3e0",
                   border: "1px solid #ffcc02",
                   borderRadius: 10,
                   padding: "14px 18px",
                   marginBottom: 16,
                   marginTop: 8,
                 }}>
                   <Typography variant="subtitle2" style={{ fontWeight: 700, color: "#e65100", marginBottom: 6 }}>
                     Voce esta prestes a excluir a conexao "{connName}"
                   </Typography>
                   <Typography variant="body2" style={{ color: "#bf360c", lineHeight: 1.6 }}>
                     Esta acao e irreversivel e causara os seguintes efeitos:
                   </Typography>
                 </Box>

                 <Box component="ul" style={{ paddingLeft: 20, margin: "0 0 16px 0" }}>
                   <Typography component="li" variant="body2" style={{ marginBottom: 6, lineHeight: 1.5 }}>
                     <strong>Tickets abertos serao perdidos</strong> — todos os tickets vinculados a esta conexao
                     que nao forem transferidos antes serao fechados ou ficarao sem conexao.
                   </Typography>
                   <Typography component="li" variant="body2" style={{ marginBottom: 6, lineHeight: 1.5 }}>
                     <strong>Historico de conversas</strong> — as mensagens dos tickets desta conexao
                     permanecirao no banco, mas sem conexao ativa para continuidade.
                   </Typography>
                   <Typography component="li" variant="body2" style={{ marginBottom: 6, lineHeight: 1.5 }}>
                     <strong>Chatbots e flows</strong> — flows e chatbots vinculados a esta conexao
                     deixarao de funcionar.
                   </Typography>
                   <Typography component="li" variant="body2" style={{ marginBottom: 6, lineHeight: 1.5 }}>
                     <strong>Filas desvinculadas</strong> — as filas associadas perderao esta conexao
                     e podem parar de receber atendimentos.
                   </Typography>
                   <Typography component="li" variant="body2" style={{ marginBottom: 6, lineHeight: 1.5 }}>
                     <strong>Horarios e automacoes</strong> — todas as configuracoes de horario,
                     mensagens automaticas e regras de inatividade serao removidas.
                   </Typography>
                   <Typography component="li" variant="body2" style={{ marginBottom: 6, lineHeight: 1.5 }}>
                     <strong>Sessao encerrada</strong> — o numero sera desconectado permanentemente
                     e precisara ser reconectado em uma nova conexao.
                   </Typography>
                 </Box>

                 <Box style={{
                   backgroundColor: "#e3f2fd",
                   border: "1px solid #90caf9",
                   borderRadius: 10,
                   padding: "14px 16px",
                   marginBottom: 20,
                   display: "flex",
                   alignItems: "center",
                   justifyContent: "space-between",
                   gap: 12,
                 }}>
                   <Typography variant="body2" style={{ color: "#1565c0", fontWeight: 500, flex: 1 }}>
                     Antes de excluir, transfira os tickets abertos para outra conexao para nao perder atendimentos.
                   </Typography>
                   <Button
                     size="small"
                     variant="contained"
                     style={{
                       backgroundColor: "#1976d2",
                       color: "#fff",
                       textTransform: "none",
                       fontWeight: 700,
                       borderRadius: 8,
                       whiteSpace: "nowrap",
                       flexShrink: 0,
                     }}
                     startIcon={<SwapHoriz />}
                     onClick={() => {
                       handleOpenTransferModal(whatsAppToDelete);
                     }}
                   >
                     Transferir tickets
                   </Button>
                 </Box>

                 <Typography variant="body2" style={{ fontWeight: 600, marginBottom: 8 }}>
                   Para confirmar, digite <strong style={{ color: "#d32f2f", fontFamily: "monospace", fontSize: 14 }}>EXCLUIR CONEXAO</strong> abaixo:
                 </Typography>
                 <TextField
                   fullWidth
                   variant="outlined"
                   size="small"
                   placeholder="EXCLUIR CONEXAO"
                   value={deleteConfirmText}
                   onChange={(e) => setDeleteConfirmText(e.target.value.toUpperCase())}
                   autoFocus
                   InputProps={{
                     style: {
                       fontFamily: "monospace",
                       fontWeight: 700,
                       fontSize: 14,
                       letterSpacing: 1,
                     },
                   }}
                   style={{ marginBottom: 8 }}
                 />
               </>
             );
           })()}
         </DialogContent>
         <DialogActions style={{ padding: "12px 24px 20px" }}>
           <Button onClick={handleClosePreDeleteModal} style={{ textTransform: "none", fontWeight: 600 }}>
             Cancelar
           </Button>
           <Button
             onClick={handleConfirmDelete}
             variant="contained"
             disabled={deleteConfirmText !== "EXCLUIR CONEXAO"}
             style={{
               backgroundColor: deleteConfirmText === "EXCLUIR CONEXAO" ? "#d32f2f" : undefined,
               color: deleteConfirmText === "EXCLUIR CONEXAO" ? "#fff" : undefined,
               textTransform: "none",
               fontWeight: 700,
               borderRadius: 8,
             }}
           >
             Excluir permanentemente
           </Button>
         </DialogActions>
       </Dialog>
      {user.profile === "user" && user.allowConnections === "disabled" ?
        <ForbiddenPage />
        :
        <>
          <MainHeader>
            <Title>{i18n.t("connections.title")} ({whatsApps.length})</Title>
            <MainHeaderButtonsWrapper>
              {/* View mode toggle */}
              <div className={classes.viewToggle}>
                <Tooltip title="Cards">
                  <button
                    className={`${classes.viewToggleBtn} ${viewMode === "cards" ? classes.viewToggleBtnActive : ""}`}
                    onClick={() => handleChangeViewMode("cards")}
                  >
                    <ViewModule style={{ fontSize: 18 }} />
                  </button>
                </Tooltip>
                <Tooltip title="Lista compacta">
                  <button
                    className={`${classes.viewToggleBtn} ${viewMode === "compact" ? classes.viewToggleBtnActive : ""}`}
                    onClick={() => handleChangeViewMode("compact")}
                  >
                    <ViewList style={{ fontSize: 18 }} />
                  </button>
                </Tooltip>
              </div>
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenTransferModal}
              >
                Transferir Tickets
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={restartWhatsapps}
              >
                {i18n.t("connections.restartConnections")}
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={() => openInNewTab(`https://wa.me/${process.env.REACT_APP_NUMBER_SUPPORT}`)}
              >
                {i18n.t("connections.callSupport")}
              </Button>
              <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                  <React.Fragment>
                    <Can
                      role={user.profile}
                      perform="connections-page:addConnection"
                      yes={() => (
                        <>
                          <Button
                            variant="contained"
                            color="primary"
                            {...bindTrigger(popupState)}
                          >
                            {i18n.t("connections.newConnection")}
                          </Button>
                          <Menu {...bindMenu(popupState)}>
                            {/* WHATSAPP */}
                            <MenuItem
                              disabled={planConfig?.plan?.useWhatsapp ? false : true}
                              onClick={() => {
                                handleOpenWhatsAppModal("whatsapp");
                                popupState.close();
                              }}
                            >
                              <WhatsApp
                                fontSize="small"
                                style={{
                                  marginRight: "10px",
                                  color: "#25D366",
                                }}
                              />
                              WhatsApp
                            </MenuItem>
                            <MenuItem
                              disabled={
                                !planConfig?.plan?.useWhatsapp ||
                                planConfig?.plan?.useWhatsMeow === false
                              }
                              onClick={() => {
                                handleOpenWhatsAppModal("wuzapi");
                                popupState.close();
                              }}
                            >
                              <img
                                src={whatsmeowIcon}
                                alt=""
                                style={{
                                  width: 24,
                                  height: 24,
                                  marginRight: 10,
                                  objectFit: "contain",
                                }}
                              />
                              Whatsapp01
                            </MenuItem>
                            <MenuItem
                              disabled={
                                !planConfig?.plan?.useWhatsapp ||
                                planConfig?.plan?.useWhatsMeow === false
                              }
                              onClick={() => {
                                handleOpenWhatsAppModal("waha");
                                popupState.close();
                              }}
                            >
                              <img
                                src={wahaIcon}
                                alt=""
                                style={{
                                  width: 24,
                                  height: 24,
                                  marginRight: 10,
                                  objectFit: "contain",
                                }}
                              />
                              Whatsapp02
                            </MenuItem>
                            <MenuItem
                              disabled={
                                !planConfig?.plan?.useWhatsapp ||
                                planConfig?.plan?.useWhatsMeow === false
                              }
                              onClick={() => {
                                handleOpenWhatsAppModal("evolution");
                                popupState.close();
                              }}
                            >
                              <img
                                src={evolutionIcon}
                                alt=""
                                style={{
                                  width: 24,
                                  height: 24,
                                  marginRight: 10,
                                  objectFit: "contain",
                                }}
                              />
                              Whatsapp03
                            </MenuItem>
                            {/* WHATSAPP OFICIAL */}
                            <MenuItem
                              disabled={planConfig?.plan?.useWhatsappOfficial ? false : true}
                              onClick={() => {
                                handleOpenWhatsAppModal("whatsapp_oficial");
                                popupState.close();
                              }}
                            >
                              <WhatsApp
                                fontSize="small"
                                style={{
                                  marginRight: "10px",
                                  color: "#25D366",
                                }}
                              />
                              WhatsApp Oficial
                            </MenuItem>
                            {/* FACEBOOK */}
                            <FacebookLogin
                              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields="name,email,picture"
                              version="9.0"
                              scope={process.env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT?.toUpperCase() === "TRUE" ?
                                "public_profile,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement,business_management"
                                : "public_profile,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement"}
                              callback={responseFacebook}
                              render={(renderProps) => (
                                <MenuItem
                                  disabled={planConfig?.plan?.useFacebook ? false : true}
                                  onClick={renderProps.onClick}
                                >
                                  <Facebook
                                    fontSize="small"
                                    style={{
                                      marginRight: "10px",
                                      color: "#3b5998",
                                    }}
                                  />
                                  Facebook
                                </MenuItem>
                              )}
                            />
                            {/* INSTAGRAM */}
                            <FacebookLogin
                              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields="name,email,picture"
                              version="9.0"
                              scope={process.env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT?.toUpperCase() === "TRUE" ?
                                "public_profile,instagram_basic,instagram_manage_messages,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement,business_management"
                                : "public_profile,instagram_basic,instagram_manage_messages,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement"}
                              callback={responseInstagram}
                              render={(renderProps) => (
                                <MenuItem
                                  disabled={planConfig?.plan?.useInstagram ? false : true}
                                  onClick={renderProps.onClick}
                                >
                                  <Instagram
                                    fontSize="small"
                                    style={{
                                      marginRight: "10px",
                                      color: "#e1306c",
                                    }}
                                  />
                                  Instagram
                                </MenuItem>
                              )}
                            />
                            <MenuItem
                              disabled={planConfig?.plan?.useConecthub360 ? false : true}
                              onClick={() => {
                                setConecthub360ModalOpen(true);
                                popupState.close();
                              }}
                            >
                              <Dashboard
                                fontSize="small"
                                style={{
                                  marginRight: "10px",
                                  color: "#7c3aed",
                                }}
                              />
                              ConectHUB 360
                            </MenuItem>
                            <MenuItem
                              disabled={planConfig?.plan?.useTelegram ? false : true}
                              onClick={() => {
                                setTelegramBotModalOpen(true);
                                popupState.close();
                              }}
                            >
                              <Send
                                fontSize="small"
                                style={{
                                  marginRight: "10px",
                                  color: "#229ED9",
                                }}
                              />
                              Telegram Bot
                            </MenuItem>
                            <MenuItem
                              disabled={planConfig?.plan?.useTelegram ? false : true}
                              onClick={() => {
                                setTelegramPersonalModalOpen(true);
                                popupState.close();
                              }}
                            >
                              <Person
                                fontSize="small"
                                style={{
                                  marginRight: "10px",
                                  color: "#229ED9",
                                }}
                              />
                              Telegram Pessoal
                            </MenuItem>
                            {/* WEBCHAT */}
                            <MenuItem
                              onClick={() => {
                                handleOpenWhatsAppModal("webchat");
                                popupState.close();
                              }}
                            >
                              <Chat
                                fontSize="small"
                                style={{
                                  marginRight: "10px",
                                  color: "#0066ff",
                                }}
                              />
                              WebChat
                            </MenuItem>
                          </Menu>
                        </>
                      )}
                    />
                  </React.Fragment>
                )}
              </PopupState>
            </MainHeaderButtonsWrapper>
          </MainHeader>

          {
            statusImport?.all ? (
              <>
                <div style={{ margin: "auto", marginBottom: 12 }}>
                  <Card className={classes.root}>
                    <CardContent className={classes.content}>
                      <Typography component="h5" variant="h5">

                        {statusImport?.this === -1 ? i18n.t("connections.buttons.preparing") : i18n.t("connections.buttons.importing")}

                      </Typography>
                      {statusImport?.this === -1 ?
                        <Typography component="h6" variant="h6" align="center">

                          <CircularProgress
                            size={24}
                          />

                        </Typography>
                        :
                        <>
                          <Typography component="h6" variant="h6" align="center">
                            {`${i18n.t(`connections.typography.processed`)} ${statusImport?.this} ${i18n.t(`connections.typography.in`)} ${statusImport?.all}  ${i18n.t(`connections.typography.date`)}: ${statusImport?.date} `}
                          </Typography>
                          <Typography align="center">
                            <CircularProgressWithLabel
                              style={{ margin: "auto" }}
                              value={(statusImport?.this / statusImport?.all) * 100}
                            />
                          </Typography>
                        </>
                      }
                    </CardContent>
                  </Card>
                </div>
              </>
            ) : null
          }

          <Paper className={classes.mainPaper} variant="outlined">
            {loading ? (
              <div className={classes.cardSkeletonGrid}>
                {[1, 2, 3, 4, 5, 6].map((n) => (
                  <div key={n} className={classes.cardSkeleton} />
                ))}
              </div>
            ) : viewMode === "compact" ? (
              /* ════════════ COMPACT LIST VIEW ════════════ */
              <div className={classes.compactList}>
                {whatsApps?.length > 0 &&
                  whatsApps.map((whatsApp) => {
                    const ch = (whatsApp.channel || "whatsapp").toLowerCase();
                    const channelColor = CHANNEL_COLORS[ch] || "#25d366";
                    const statusInfo = STATUS_MAP[whatsApp.status] || { label: whatsApp.status, color: "#9e9e9e", bg: "rgba(158,158,158,0.08)" };
                    const stats = connectionStats[whatsApp.id] || {};

                    const phoneNumber =
                      (ch === "whatsapp" && String(whatsApp.number || "").trim())
                        ? formatSerializedId(whatsApp.number)
                        : ["wuzapi", "whatsmeow", "waha", "evolution"].includes(ch) && String(whatsApp.number || "").trim()
                          ? formatSerializedId(whatsApp.number)
                          : ch === "whatsapp_oficial" && String(whatsApp.phone_number || "").trim()
                            ? formatSerializedId(whatsApp.phone_number)
                            : null;

                    return (
                      <div key={whatsApp.id} className={classes.compactItem}>
                        <div className={classes.compactColorDot} style={{ backgroundColor: whatsApp.color || channelColor }} />
                        <div className={classes.compactChannelIcon} style={{ backgroundColor: `${channelColor}14` }}>
                          {IconChannel(whatsApp.channel)}
                        </div>
                        <Typography className={classes.compactName} title={whatsApp.name}>
                          {whatsApp.name}
                        </Typography>
                        <Tooltip title={statusInfo.label}>
                          <span
                            className={`${classes.compactStatusDot} ${whatsApp.status === "CONNECTED" ? classes.healthPulse : ""}`}
                            style={{ backgroundColor: statusInfo.color }}
                          />
                        </Tooltip>
                        <Typography className={classes.compactPhone}>
                          {phoneNumber || "-"}
                        </Typography>
                        <div className={classes.compactStats}>
                          <Tooltip title={`${stats.openTickets || 0} abertos / ${stats.pendingTickets || 0} pendentes`}>
                            <span style={{ display: "inline-flex", alignItems: "center", gap: 2 }}>
                              <Inbox style={{ fontSize: 13, color: (stats.openTickets || 0) > 0 ? "#ff9800" : "#ccc" }} />
                              {stats.openTickets || 0}
                            </span>
                          </Tooltip>
                          <Tooltip title={`${stats.messagesToday || 0} msgs hoje`}>
                            <span style={{ display: "inline-flex", alignItems: "center", gap: 2 }}>
                              <Message style={{ fontSize: 13, color: (stats.messagesToday || 0) > 0 ? "#2196f3" : "#ccc" }} />
                              {stats.messagesToday || 0}
                            </span>
                          </Tooltip>
                          <Tooltip title={`${stats.closedToday || 0} fechados hoje`}>
                            <span style={{ display: "inline-flex", alignItems: "center", gap: 2 }}>
                              <CheckCircle style={{ fontSize: 13, color: (stats.closedToday || 0) > 0 ? "#4caf50" : "#ccc" }} />
                              {stats.closedToday || 0}
                            </span>
                          </Tooltip>
                          <span style={{ color: "#bbb" }}>{getTimeSinceUpdate(whatsApp.updatedAt)}</span>
                          {whatsApp.isDefault && <span className={classes.defaultBadge}>Padrao</span>}
                        </div>
                        <div className={classes.compactActions}>
                          {renderActionButtons(whatsApp)}
                          <Can
                            role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
                            perform="connections-page:addConnection"
                            yes={() => (
                              <>
                                <IconButton size="small" onClick={() => handleEditWhatsApp(whatsApp)}>
                                  <Edit style={{ fontSize: 16 }} />
                                </IconButton>
                                <IconButton size="small" onClick={() => { setCloneSource(whatsApp); setCloneModalOpen(true); }}>
                                  <FileCopy style={{ fontSize: 16 }} />
                                </IconButton>
                                <IconButton size="small" onClick={() => handleOpenTransferModal(whatsApp.id)}>
                                  <SwapHoriz style={{ fontSize: 16 }} />
                                </IconButton>
                                <IconButton size="small" onClick={() => handleOpenPreDeleteModal(whatsApp.id)}>
                                  <DeleteOutline style={{ fontSize: 16 }} />
                                </IconButton>
                              </>
                            )}
                          />
                        </div>
                      </div>
                    );
                  })}
              </div>
            ) : (
              /* ════════════ CARDS VIEW ════════════ */
              <div className={classes.cardGrid}>
                {whatsApps?.length > 0 &&
                  whatsApps.map((whatsApp) => {
                    const ch = (whatsApp.channel || "whatsapp").toLowerCase();
                    const channelColor = CHANNEL_COLORS[ch] || "#25d366";
                    const statusInfo = STATUS_MAP[whatsApp.status] || { label: whatsApp.status, color: "#9e9e9e", bg: "rgba(158,158,158,0.08)" };
                    const stats = connectionStats[whatsApp.id] || {};

                    const phoneNumber =
                      (ch === "whatsapp" && String(whatsApp.number || "").trim())
                        ? formatSerializedId(whatsApp.number)
                        : ["wuzapi", "whatsmeow", "waha", "evolution"].includes(ch) && String(whatsApp.number || "").trim()
                          ? formatSerializedId(whatsApp.number)
                          : ch === "whatsapp_oficial" && String(whatsApp.phone_number || "").trim()
                            ? formatSerializedId(whatsApp.phone_number)
                            : null;

                    return (
                      <div key={whatsApp.id} className={classes.connectionCard}>
                        {/* Color stripe */}
                        <div
                          className={classes.cardColorStripe}
                          style={{ backgroundColor: whatsApp.color || channelColor }}
                        />

                        {/* Header: channel icon + name | status + badges */}
                        <div className={classes.cardHeader}>
                          <div className={classes.cardChannelInfo}>
                            <div
                              className={classes.cardChannelIcon}
                              style={{ backgroundColor: `${channelColor}14` }}
                            >
                              {IconChannel(whatsApp.channel)}
                            </div>
                            <div>
                              <Typography className={classes.cardName} title={whatsApp.name}>
                                {whatsApp.name}
                              </Typography>
                              <Typography className={classes.cardChannelLabel}>
                                {CHANNEL_LABELS[ch] || ch}
                                {phoneNumber && <span style={{ marginLeft: 6, fontWeight: 400, letterSpacing: 0 }}>{phoneNumber}</span>}
                              </Typography>
                            </div>
                          </div>
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 4 }}>
                            <span
                              className={classes.cardStatusChip}
                              style={{
                                color: statusInfo.color,
                                backgroundColor: statusInfo.bg,
                              }}
                            >
                              {whatsApp.status === "CONNECTED" && (
                                <span className={`${classes.healthDot} ${classes.healthPulse}`} style={{ backgroundColor: "#4caf50" }} />
                              )}
                              {statusInfo.label}
                            </span>
                            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                              {whatsApp.isDefault && (
                                <span className={classes.defaultBadge}>Padrao</span>
                              )}
                              {whatsApp.inboundOnly && (
                                <Tooltip title={i18n.t("whatsappModal.form.inboundOnlyHelper")}>
                                  <span className={classes.inboundBadge}>
                                    {i18n.t("connections.inboundOnlyBadge")}
                                  </span>
                                </Tooltip>
                              )}
                              {whatsApp.battery != null && (
                                <Tooltip title={`Bateria: ${whatsApp.battery}%${whatsApp.plugged ? " (carregando)" : ""}`}>
                                  <span className={classes.batteryIndicator}>
                                    {whatsApp.battery > 20
                                      ? <BatteryFull style={{ fontSize: 13, color: whatsApp.battery > 50 ? "#4caf50" : "#ff9800" }} />
                                      : <BatteryAlert style={{ fontSize: 13, color: "#f44336" }} />
                                    }
                                    {whatsApp.battery}%
                                  </span>
                                </Tooltip>
                              )}
                              {whatsApp.retries > 0 && (
                                <Tooltip title={`${whatsApp.retries} tentativas de reconexao`}>
                                  <span style={{ fontSize: 10, color: "#ff9800", fontWeight: 600 }}>
                                    {whatsApp.retries}x
                                  </span>
                                </Tooltip>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Body: updated + receive comments */}
                        <div className={classes.cardBody}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <Typography style={{ fontSize: 11, color: "#aaa" }}>
                              {format(parseISO(whatsApp.updatedAt), "dd/MM/yy HH:mm")} ({getTimeSinceUpdate(whatsApp.updatedAt)})
                            </Typography>
                            {(whatsApp.channel === "facebook" || whatsApp.channel === "instagram") && (
                              <Tooltip
                                title={
                                  whatsApp.receiveComments
                                    ? i18n.t("connections.receiveComments.tooltip.enabled")
                                    : i18n.t("connections.receiveComments.tooltip.disabled")
                                }
                              >
                                <Box display="flex" alignItems="center" style={{ gap: 3 }}>
                                  <Typography style={{ fontSize: 10, color: "#888" }}>Comentarios</Typography>
                                  <Switch
                                    checked={whatsApp.receiveComments !== false}
                                    onChange={() => handleToggleReceiveComments(whatsApp)}
                                    color="primary"
                                    size="small"
                                  />
                                </Box>
                              </Tooltip>
                            )}
                          </div>
                        </div>

                        {/* Stats row — always visible */}
                        <div className={classes.cardStatsRow}>
                          <Tooltip title={`${stats.openTickets || 0} ticket${(stats.openTickets || 0) !== 1 ? "s" : ""} aberto${(stats.openTickets || 0) !== 1 ? "s" : ""}`}>
                            <span className={classes.statChip} style={{
                              backgroundColor: (stats.openTickets || 0) > 0 ? "rgba(255,152,0,0.12)" : "rgba(0,0,0,0.04)",
                              color: (stats.openTickets || 0) > 0 ? "#e65100" : "#999",
                            }}>
                              <Inbox style={{ fontSize: 12 }} />
                              {stats.openTickets || 0} abertos
                            </span>
                          </Tooltip>
                          <Tooltip title={`${stats.pendingTickets || 0} ticket${(stats.pendingTickets || 0) !== 1 ? "s" : ""} pendente${(stats.pendingTickets || 0) !== 1 ? "s" : ""}`}>
                            <span className={classes.statChip} style={{
                              backgroundColor: (stats.pendingTickets || 0) > 0 ? "rgba(33,150,243,0.10)" : "rgba(0,0,0,0.04)",
                              color: (stats.pendingTickets || 0) > 0 ? "#1565c0" : "#999",
                            }}>
                              <FiberManualRecord style={{ fontSize: 8 }} />
                              {stats.pendingTickets || 0} pendentes
                            </span>
                          </Tooltip>
                          <Tooltip title={`${stats.messagesToday || 0} mensagen${(stats.messagesToday || 0) !== 1 ? "s" : ""} hoje`}>
                            <span className={classes.statChip} style={{
                              backgroundColor: (stats.messagesToday || 0) > 0 ? "rgba(76,175,80,0.10)" : "rgba(0,0,0,0.04)",
                              color: (stats.messagesToday || 0) > 0 ? "#2e7d32" : "#999",
                            }}>
                              <Message style={{ fontSize: 12 }} />
                              {stats.messagesToday || 0} msgs
                            </span>
                          </Tooltip>
                          <Tooltip title={`${stats.closedToday || 0} ticket${(stats.closedToday || 0) !== 1 ? "s" : ""} fechado${(stats.closedToday || 0) !== 1 ? "s" : ""} hoje`}>
                            <span className={classes.statChip} style={{
                              backgroundColor: (stats.closedToday || 0) > 0 ? "rgba(76,175,80,0.08)" : "rgba(0,0,0,0.04)",
                              color: (stats.closedToday || 0) > 0 ? "#1b5e20" : "#999",
                            }}>
                              <CheckCircle style={{ fontSize: 12 }} />
                              {stats.closedToday || 0} fechados
                            </span>
                          </Tooltip>
                          {(stats.queuesCount || 0) > 0 && (
                            <Tooltip title={`${stats.queuesCount} fila${stats.queuesCount > 1 ? "s" : ""} vinculada${stats.queuesCount > 1 ? "s" : ""}`}>
                              <span className={classes.statChip} style={{ backgroundColor: "rgba(156,39,176,0.08)", color: "#7b1fa2" }}>
                                {stats.queuesCount} fila{stats.queuesCount > 1 ? "s" : ""}
                              </span>
                            </Tooltip>
                          )}
                          {/* Gallera Chat: liga/desliga visível sem abrir a conexão (22/09/2026) */}
                          {whatsApp.channel === "webchat" ? (
                            <Tooltip title={whatsApp.webchatEnabled
                              ? "Chat ligado: clientes conseguem abrir a conversa. Para desligar, edite a conexão."
                              : "Chat desligado: ninguém consegue abrir a conversa. Para ligar, edite a conexão."}>
                              <span className={classes.statChip} style={whatsApp.webchatEnabled
                                ? { backgroundColor: "rgba(26,139,74,0.12)", color: "#1a8b4a" }
                                : { backgroundColor: "rgba(0,0,0,0.06)", color: "#757575" }}>
                                {whatsApp.webchatEnabled ? "Chat ligado" : "Chat desligado"}
                              </span>
                            </Tooltip>
                          ) : whatsApp.webchatEnabled ? (
                            <Tooltip title="Esta conexão convida os clientes para o chat próprio (link na saudação). Para parar, edite a conexão.">
                              <span className={classes.statChip} style={{ backgroundColor: "rgba(0,102,255,0.10)", color: "#0066ff" }}>
                                Convida p/ chat
                              </span>
                            </Tooltip>
                          ) : null}
                        </div>

                        {/* Session actions (QR code, disconnect, etc.) */}
                        <div className={classes.cardSessionArea}>
                          {renderActionButtons(whatsApp)}
                        </div>

                        {/* Divider + Admin actions */}
                        <Can
                          role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
                          perform="connections-page:addConnection"
                          yes={() => (
                            <>
                              <hr className={classes.cardDivider} style={{ border: "none", borderTop: "1px solid", borderColor: "inherit", opacity: 0.15 }} />
                              <div className={classes.cardActions}>
                                <Tooltip title="Editar">
                                  <IconButton size="small" onClick={() => handleEditWhatsApp(whatsApp)}>
                                    <Edit fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title={i18n.t("connections.buttons.clone") || "Clonar conexao"}>
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      setCloneSource(whatsApp);
                                      setCloneModalOpen(true);
                                    }}
                                  >
                                    <FileCopy fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Transferir tickets desta conexao">
                                  <IconButton size="small" onClick={() => handleOpenTransferModal(whatsApp.id)}>
                                    <SwapHoriz fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Excluir">
                                  <IconButton size="small" onClick={() => handleOpenPreDeleteModal(whatsApp.id)}>
                                    <DeleteOutline fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                {whatsApp.channel === "whatsapp_oficial" && (
                                  <>
                                    <Tooltip title="Sincronizar templates">
                                      <IconButton size="small" onClick={() => handleSyncTemplates(whatsApp.id)}>
                                        <Sync fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Copiar URL de Webhook para a Meta">
                                      <IconButton size="small" onClick={() => handleCopyWebhook(whatsApp)}>
                                        <WebhookIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </>
                                )}
                              </div>
                            </>
                          )}
                        />
                      </div>
                    );
                  })}
              </div>
            )}
          </Paper>
        </>
      }
    </MainContainer >

  );
};

export default Connections;